module.exports = __webpack_public_path__ + "static/media/jacobs.3603aa9a.png";